
import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {LoginComponent} from "./login.component";
import {RouterModule} from "@angular/router";
import {AccountActivatingComponent} from "./account-activating.component";
import {ResetPasswordComponent} from "./reset-password.component";
import {ConfirmResetPasswordComponent} from "./confirm-reset.component";
import {AccountActivatedComponent} from "./account-activated.component";
import {LoginSSOComponent} from "@webmate-web-core/authentication/login-sso.component";
import {SSOHelperComponent} from "@webmate-web-core/authentication/sso-helper.component";
import {SignupComponent} from '@webmate-web-core/authentication/signup.component';
import {LoginContainerComponent} from '@webmate-web-core/authentication/login-container.component';
import {InputTextModule} from 'primeng/inputtext';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PasswordModule} from 'primeng/password';
import {CheckboxModule} from 'primeng/checkbox';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ButtonModule} from 'primeng/button';
import {ResourceViewsModule} from "@webmate-web-core/shared/components/resources/resource-views.module";
import {ApplyChangeEmailTokenComponent} from "@webmate-web-core/authentication/apply-change-email-token.component";
import {ErrorMessagePipe} from "@webmate-web-core/shared/utils/pipes/error.pipe";


@NgModule({
    declarations: [
        LoginComponent,
        LoginSSOComponent,
        AccountActivatingComponent,
        AccountActivatedComponent,
        ResetPasswordComponent,
        ConfirmResetPasswordComponent,
        ApplyChangeEmailTokenComponent,
        SSOHelperComponent,
        SignupComponent,
        LoginContainerComponent
    ],
	imports: [
		CommonModule,
		RouterModule,
		InputTextModule,
		PasswordModule,
		CheckboxModule,
		FormsModule,
		ReactiveFormsModule,
		FontAwesomeModule,
		ProgressSpinnerModule,
		ButtonModule,
		ResourceViewsModule,
		ErrorMessagePipe
	],
    exports: [
        LoginComponent,
        LoginSSOComponent,
        AccountActivatingComponent,
        AccountActivatedComponent,
        ResetPasswordComponent,
        ConfirmResetPasswordComponent,
        ApplyChangeEmailTokenComponent,
        SSOHelperComponent,
        SignupComponent,
        LoginContainerComponent
    ]
})
export class AuthenticationModule { }
